import CacheActions from './CacheActions'
import DimensionActions from './DimensionActions'
import EntryActions from './EntryActions'
import HelpActions from './HelpActions'
import LeaderBoardActions from './LeaderboardActions'
import LeagueActions from './LeagueActions'
import MatchActions from './MatchActions'
import NavigationActions from './NavigationActions'
import NotificationActions from './NotificationActions'
import RewardActions from './RewardActions'
import ShareActions from './ShareActions'
import SponsorsActions from './SponsorsActions'
import TransactionActions from './TransactionActions'
import UserActions from './UserActions'

import ActionTypes from './types/ActionTypes'
import DataActionTypes from './types/DataActionTypes'

const CCActions = {
    ...CacheActions,
    ...DimensionActions,
    ...EntryActions,
    ...HelpActions,
    ...LeaderBoardActions,
    ...LeagueActions,
    ...MatchActions,
    ...NavigationActions,
    ...NotificationActions,
    ...RewardActions,
    ...ShareActions,
    ...SponsorsActions,
    ...TransactionActions,
    ...UserActions,

};

export {CCActions, DataActionTypes, ActionTypes}


// WEBPACK FOOTER //
// ./src/app/data/actions/index.js